import React from 'react';
import TableManager from '../components/data/TableManager';

const columnConfig = [
  "ABO_Id_AbilitazioniOperazioni=1,ID",
  "ABO_IdRif_AbilitazioniOperazioni=1,ID Rif.,type=number",
  "ABO_Id_ProcedureApplicative=2,Procedura Applicativa", // Lookup
  "ABO_Id_GruppiAbilitazioni=2,Gruppo Abilitazioni", // Lookup
  "ABO_Accesso=2,Accesso,type=boolean",
  "ABO_Inserimento=2,Inserimento,type=boolean",
  "ABO_Modifica=2,Modifica,type=boolean",
  "ABO_GestioneAvanzata=2,Gestione Avanzata,type=boolean",
  "ABO_InizioValidita=1,Inizio Validità,type=datetime",
  "ABO_FineValidita=1,Fine Validità,type=datetime",
  "ABO_StatoRecord=2,Stato Record", // Lookup
  "ABO_UtenteInserimento=0,Utente Inserimento",
  "ABO_DataOraInserimento=0,Data/Ora Inserimento",
  "ABO_TerminaleInserimento=0,Terminale Inserimento",
  "ABO_UtenteModifica=0,Utente Modifica",
  "ABO_DataOraModifica=0,Data/Ora Modifica",
  "ABO_TerminaleModifica=0,Terminale Modifica",
  "ABO_Utente=0,Utente Audit",
  "ABO_Terminale=0,Terminale Audit",
  "ABO_Timestamp=0,Timestamp DB"
];

const filterConfig = [
  { field: 'ABO_Id_ProcedureApplicative', label: 'Procedura Applicativa', type: 'lookup', lookupName: 'funzioniAppLookup' },
  { field: 'ABO_Id_GruppiAbilitazioni', label: 'Gruppo Abilitazioni', type: 'lookup', lookupName: 'gruppiAbilitazioniLookup' },
  { field: 'ABO_StatoRecord', label: 'Stato Record', type: 'lookup', lookupName: 'statiRecordChar' },
];

const lookupConfig = {
  statiRecordChar: {
    options: [
      { value: 'A', label: 'Attivo' },
      { value: 'S', label: 'Sospeso' },
      { value: 'D', label: 'Disattivo' },
    ],
  },
  funzioniAppLookup: {
    tableName: 'SKE_FunzioniApp', // Assicurati che SKE_FunzioniApp sia gestita da TableManager o API
    valueField: 'FUA_Id_FunzioniApp',
    labelField: 'FUA_NomeFunzione', // O FUA_CodiceFunzione se più appropriato
  },
  gruppiAbilitazioniLookup: {
    tableName: 'DOM_GruppiAbilitazioni',
    valueField: 'GAB_Id_GruppiAbilitazioni',
    labelField: 'GAB_Descrizione',
  }
};

const inputTypes = {
  ABO_InizioValidita: 'datetime-local',
  ABO_FineValidita: 'datetime-local',
};

const AbilitazioniOperazioniPage = () => {
  return (
    <TableManager
      tableName="SKE_AbilitazioniOperazioni"
      primaryKey="ABO_Id_AbilitazioniOperazioni"
      pageTitle="Gestione Abilitazioni Operazioni"
      columnConfig={columnConfig}
      filterConfig={filterConfig}
      lookupConfig={lookupConfig}
      inputTypes={inputTypes}
      enableCreate={true}
      enableEdit={true}
      enableDelete={true}
    />
  );
};

export default AbilitazioniOperazioniPage;